import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inscrip-formulaire',
  templateUrl: './inscrip-formulaire.component.html',
  styleUrls: ['./inscrip-formulaire.component.css']
})
export class InscripFormulaireComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
